import { type Opportunity, OpportunityStatusEnum } from "@repo/api";
import { RadioButtonGroup } from "@repo/skapa";
import { t } from "@repo/translation";
import { SectionContainer } from "@repo/ui";
import { hasItems, trackAnalytics } from "@repo/utils";
import { type ChangeEvent } from "react";

import { TextAreaField } from "./components/TextAreaField";

const progressItems: OpportunityStatusEnum[] = [
  OpportunityStatusEnum.Unassigned,
  OpportunityStatusEnum.Assigned,
  OpportunityStatusEnum.InProgress,
  OpportunityStatusEnum.ClosedWon,
  OpportunityStatusEnum.ClosedLost,
  OpportunityStatusEnum.Invalid,
];

export const ProjectProgressSelector = ({
  currentStatus,
  selectedStatus,
  setSelectedStatus,
  setSelectedReason,
  setDescription,
  reasons,
}: {
  reasons: string[] | undefined;
  setDescription: (description: string | undefined) => void;
  setSelectedReason: (reason: string | undefined) => void;
  setSelectedStatus: (status: Opportunity["status"]) => void;
  selectedStatus: Opportunity["status"] | undefined;
  currentStatus: Opportunity["status"] | undefined;
}) => {
  return (
    <>
      <RadioButtonGroup
        name={t("action.select_status")}
        list={progressItems.map((item) => ({
          name: "status-list",
          id: item,
          label: t(`status.${item.toLowerCase()}`),
          value: item,
          defaultChecked: item === currentStatus,
          onChange: (e: ChangeEvent<HTMLInputElement>) => {
            setSelectedStatus(e.target.value as Opportunity["status"]);
            trackAnalytics("select_status");
          },
        }))}
      />
      {hasItems(reasons) && (
        <SectionContainer>
          <RadioButtonGroup
            name={t("action.select_reason")}
            list={reasons.map((key) => ({
              name: "reason-list",
              id: key,
              label: t(`status_change_reason.${selectedStatus}_${key}`),
              value: key,
              onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                setSelectedReason(e.target.value);
                trackAnalytics("status_change_reason");
              },
            }))}
          />
          <TextAreaField
            id="description"
            label={t("action.describe_reason")}
            value=""
            editable={true}
            onChange={setDescription}
          />
        </SectionContainer>
      )}
    </>
  );
};
